import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { LuLock, LuTrash2, LuChevronRight } from "react-icons/lu";
import "./settings.css";

const Settings = ({ isLoggedIn, loginUser, onLogout }) => {
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  if (!isLoggedIn) {
    navigate("/");
    return;
  }

  const handleDeleteAccount = async () => {
    if (deleteConfirmText !== "DELETE") return;
    setIsDeleting(true);
    try {
      await axios.delete("/api/v1/user/delete-account");
      toast.success("Account deleted successfully.");
      onLogout();
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete account.");
      setIsDeleting(false);
    }
  };

  return (
    <div className="sr-settings">
      <div className="sr-settings__top">
        <div className="sr-settings__top-content">
          <h1 className="sr-settings__title">Settings</h1>
        </div>
      </div>

      <div className="sr-settings__body">
        {/* ── Change Password ── */}
        {!loginUser.googleId && (
          <Link to="/change-password" className="sr-settings__item">
            <div className="sr-settings__item-left">
              <div className="sr-settings__item-icon">
                <LuLock />
              </div>
              <div className="sr-settings__item-text">
                <span className="sr-settings__item-title">Change Password</span>
                <span className="sr-settings__item-desc">Update your account password</span>
              </div>
            </div>
            <LuChevronRight className="sr-settings__item-arrow" />
          </Link>
        )}

        {/* ── Delete Account ── */}
        {!showDeleteConfirm ? (
          <button className="sr-settings__item sr-settings__item--danger" onClick={() => setShowDeleteConfirm(true)}>
            <div className="sr-settings__item-left">
              <div className="sr-settings__item-icon sr-settings__item-icon--danger">
                <LuTrash2 />
              </div>
              <div className="sr-settings__item-text">
                <span className="sr-settings__item-title sr-settings__item-title--danger">Delete Account</span>
                <span className="sr-settings__item-desc">Permanently remove your account and data</span>
              </div>
            </div>
            <LuChevronRight className="sr-settings__item-arrow" />
          </button>
        ) : (
          <div className="sr-settings__delete-panel">
            <h3 className="sr-settings__delete-title">Delete Account</h3>
            <p className="sr-settings__delete-warning">This will permanently delete your account, rides, bookings, and all associated data. This action cannot be undone.</p>
            <div className="sr-settings__delete-group">
              <label className="sr-settings__delete-label" htmlFor="delete-confirm">Type DELETE to confirm</label>
              <input
                className="sr-settings__delete-input"
                type="text"
                id="delete-confirm"
                value={deleteConfirmText}
                onChange={(e) => setDeleteConfirmText(e.target.value)}
                placeholder="DELETE"
                autoComplete="off"
              />
            </div>
            <div className="sr-settings__delete-actions">
              <button className="sr-settings__btn sr-settings__btn--secondary" type="button" onClick={() => { setShowDeleteConfirm(false); setDeleteConfirmText(""); }}>
                Cancel
              </button>
              <button
                className="sr-settings__btn sr-settings__btn--danger"
                type="button"
                onClick={handleDeleteAccount}
                disabled={deleteConfirmText !== "DELETE" || isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete Account"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
